import { useEffect } from 'react';

/** Set the document title and meta description while this page is on screen. */
export function usePageMeta(title: string, description: string): void {
  useEffect(() => {
    const meta = document.querySelector('meta[name="description"]');
    const previousTitle = document.title;
    const previousDescription = meta?.getAttribute('content') ?? '';
    document.title = title;
    if (meta) meta.setAttribute('content', description);
    return () => {
      document.title = previousTitle;
      if (meta) meta.setAttribute('content', previousDescription);
    };
  }, [title, description]);
}
